import { Statistic } from '@indigo-ag/component-module';
import { DecisionSheetDebt } from '@indigo-ag/schema';
import i18next from 'i18next';
import React from 'react';
import { currency } from 'shared';
import styled from 'styled-components';
import { DebtsTable } from './DebtsTable';

const EMPTY_VALUE = '-';

const NoResultsContainer = styled.div`
  margin: 32px;
`;

const StatContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 20px 0;
`;

interface Props {
  debts?: DecisionSheetDebt[] | null;
  debtsCount?: number | null;
  debtsTotal?: number | null;
}

export const DebtsContent = ({ debts, debtsCount, debtsTotal }: Props) => {
  if (!debts) {
    return <NoResultsContainer>{i18next.t('couldntFetchData')}</NoResultsContainer>;
  }

  return (
    <>
      <StatContainer>
        <Statistic
          value={debtsCount != null ? debtsCount.toString() : EMPTY_VALUE}
          label={i18next.t('consultationsCard_outstandingDebts')}
        />
        <Statistic
          value={debtsTotal != null ? currency.formatBrazilCurrency(debtsTotal) : EMPTY_VALUE}
          label={i18next.t('consultationsCard_value')}
        />
      </StatContainer>
      <DebtsTable debts={debts} />
    </>
  );
};
